// @ts-nocheck
import * as arrayUtil from './arrayUtils';

export function isCheckInOption(flightSectorOptionalExtras, option) {
    if (!flightSectorOptionalExtras || !flightSectorOptionalExtras.length) {
        return false;
    }
    let result = false;
    angular.forEach(flightSectorOptionalExtras, function(sector) {
        if (sector.CheckInOptions && sector.CheckInOptions.length) {
            const checkInOptions = sector.CheckInOptions[0].MultiOptionalExtras[0].Options;
            if (arrayUtil.any(checkInOptions, o => o.OptionId === option.OptionId)) {
                result = true;
            }
        }
    });
    return result;
}

export function findOptionInDetails(sector, o) {
    let pos = null;
    angular.forEach(sector.NonCheckInOptions, function(oe, oei) {
        angular.forEach(oe.MultiOptionalExtras, function(mo, mi) {
            const i = arrayUtil.indexOf(mo.Options, function(opt) {
                return angular.equals(opt.Key, o);
            });
            pos = pos || (i >= 0 ? { groupIndex: oei, optionIndex: mi, key: mo.Options[i].Key } : null);
        });
    });
    return pos;
}

export function isSingleOption(sector, o) {
    let s = false;
    angular.forEach(sector.OptionalExtras, function(oe) {
        s = s || (arrayUtil.indexOf(oe.SingleOptionalExtras, function(so) {
            return angular.equals(so.Key, o);
        }) >= 0);
    });
    return s;
}

export function parseMultiOptions(sector, opts) {
    const selected = [];
    angular.forEach(sector.NonCheckInOptions, function() {
        selected.push([]);
    });
    angular.forEach(opts, function(o) {
        const pos = findOptionInDetails(sector, o);
        if (pos) {
            if (selected[pos.groupIndex] == null) {
                selected[pos.groupIndex] = [];
            }
            selected[pos.groupIndex][pos.optionIndex] = pos.key;
        }
    });
    return selected;
}

function parseSeatOptions(opts) {
    return arrayUtil.filter(opts, function(o) {
        return o.OptionId.indexOf('Seat::') === 0;
    });
}

export function parseSingleOptions(sector, opts) {
    return arrayUtil.filter(opts, function(o) {
        return isSingleOption(sector, o);
    });
}

export function baggageSelected(sector, selected) {
    let ok = true;

    angular.forEach(arrayUtil.filter(sector.OptionalExtras, function(oe) { return oe.Type === 0; }), function(oe) {
        //make sure that *all* single baggage options are selected
        angular.forEach(oe.SingleOptionalExtras, function(soe) {
            ok = ok && arrayUtil.any(selected, function(s) {
                return s.OptionId === soe.Key.OptionId;
            });
        });

        //make sure one of each multi baggage options are selected
        angular.forEach(oe.MultiOptionalExtras, function(moe) {
            let mok = false;
            angular.forEach(moe.Options, function(o) {
                mok = mok || arrayUtil.any(selected, function(s) {
                    return s.OptionId === o.Key.OptionId;
                });
            });
            ok = ok && mok;
        });
    });

    return ok;
}

export function parseSelectedOptions(sector, opts) {
    return {
        selectedMultiOptions: parseMultiOptions(sector, opts),
        selectedOptions: parseSingleOptions(sector, opts),
        selectedSeats: parseSeatOptions(opts)
    };
}
